module.exports = __webpack_public_path__ + "static/media/StepguideSpiderAIS.7dd4d7f3.PNG";